import React, { useState } from 'react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-0 w-full bg-funeral-dark/95 backdrop-blur-md z-50 border-b border-funeral-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="font-serif text-2xl font-semibold text-funeral-gold tracking-wider">
            Kenangan.AI
          </div>
          
          <div className="hidden md:flex space-x-8">
            <a href="#home" className="text-funeral-light hover:text-funeral-gold transition-colors">Home</a>
            <a href="#about" className="text-funeral-light hover:text-funeral-gold transition-colors">Tentang Kami</a>
            <a href="#cara-kerja" className="text-funeral-light hover:text-funeral-gold transition-colors">Cara Kerja</a>
            <a href="#faq" className="text-funeral-light hover:text-funeral-gold transition-colors">FAQ</a>
            <a href="#contact" className="text-funeral-light hover:text-funeral-gold transition-colors">Hubungi Kami</a>
          </div>

          <button 
            className="md:hidden text-funeral-light"
            onClick={() => setIsOpen(!isOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-funeral-secondary border-t border-funeral-border">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <a href="#home" className="block px-3 py-2 text-funeral-light hover:text-funeral-gold transition-colors">Home</a>
            <a href="#about" className="block px-3 py-2 text-funeral-light hover:text-funeral-gold transition-colors">Tentang Kami</a>
            <a href="#cara-kerja" className="block px-3 py-2 text-funeral-light hover:text-funeral-gold transition-colors">Cara Kerja</a>
            <a href="#faq" className="block px-3 py-2 text-funeral-light hover:text-funeral-gold transition-colors">FAQ</a>
            <a href="#contact" className="block px-3 py-2 text-funeral-light hover:text-funeral-gold transition-colors">Hubungi Kami</a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
